import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import invoicesServices from '@src/services/invoices.services';

export const getPagedList = createAsyncThunk(
  'getPagedList',
  async ({ body }, { rejectWithValue }) => {
    try {
      const result = await invoicesServices.getPagedList({ body });
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const baBsGetList = createAsyncThunk(
  'baBsGetList',
  async ({ body }, { rejectWithValue }) => {
    try {
      const result = await invoicesServices.baBsGetList({ body });
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);


export const currentAccountList = createAsyncThunk(
  'currentAccountList',
  async ({ body }, { rejectWithValue }) => {
    try {
      const result = await invoicesServices.currentAccountGetList({ body });
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

const initialState = {
  invoicesList: [],
  baBsList: [],
  currentAccounts: [],
};

export const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getPagedList.fulfilled, (state, action) => {
      state.invoicesList = action?.payload?.data?.items;
    });
    builder.addCase(baBsGetList.fulfilled, (state, action) => {
      state.baBsList = action?.payload?.data;
    });
    builder.addCase(currentAccountList.fulfilled, (state, action) => {
      state.currentAccounts = action?.payload?.data?.items;
    });
  },
});
